import Axios from '@/shared/api/axios';

/**
 * 重抓單篇貼文 / 世界觀。
 *
 * 兩者的 endpoint 與 uuid 參數名不同，對照表集中在這裡，
 * 呼叫端（貼文卡片編輯/解鎖後就地更新、聊天室站內連結預覽）不必各自維護一份。
 *
 * 狀態碼不在這裡處理：呼叫端顯示錯誤的方式不同（StatusModal、預覽失敗樣式），
 * 一律回傳後端原始 payload 交由呼叫端決定。
 *
 * @param {Object} options
 * @param {'post'|'world'} options.contentType
 * @param {string} options.uuid
 * @param {number} options.idolId
 * @returns {Promise<{status_code: string, data: Object}>}
 */
export async function fetchContentItem({ contentType, uuid, idolId }) {
  const isWorld = contentType === 'world';
  const endpoint = isWorld ? '/world/get-info' : '/post/get-only';
  const params = isWorld
    ? { idol_id: idolId, world_uuid: uuid }
    : { idol_id: idolId, post_uuid: uuid };

  const res = await Axios.post(endpoint, params);
  return res.data;
}
